module.exports = {
  title: '汽车厂商管理',
  route: {
    path: '/platform-goods-manage',
    children: {
      path: 'cars-firm-manage',
    },
  },
};
